import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  colors,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: colors.red[900],
  },
  actions: {
    backgroundColor: colors.red[900],
  },
  button: {
    color: "white",
  },
}));

const Error = ({ message: { message }, onClose = () => {} }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const { t } = useTranslation();

  const errorMessage = t(`errors.${message}`).startsWith("errors.")
    ? message
    : t(`errors.${message}`);

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Box>
            <ErrorIcon fontSize="large" className={classes.icon} />
          </Box>
          <Box mt={1}>
            <Typography variant="h3">Error</Typography>
          </Box>
          <Box mt={1}>
            <Typography variant="body2">{errorMessage}</Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={1}
        >
          <Button fullWidth className={classes.button} onClick={handleClose}>
            Dismiss
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default Error;
